export default {
  state: {
    logUrl: '', // 发送埋点的url
    loggerResult: [], // 埋点数据统计
    logLength: 5, // 最大存储埋点数量
    logTime: 60, //  发送埋点间隔时间
  },
  getters: {
    getLogTime: state => state.logTime,
    getLoggerResult: state => state.loggerResult
  },
  mutations: {
    
    appendLogger: (state, payload) => {
      state.loggerResult.push(payload)
    },
    
    resetLogger: (state) => state.loggerResult = [],
  },
  actions: {
    dealLogger({ state, commit, dispatch }, payload) {
      commit('appendLogger', payload)
      const res = state.loggerResult
      if (res.length >= state.logLength) {
        dispatch('sendLogger')
      }
    },
    
    sendLogger({ state, commit }) {
      const res = state.loggerResult
      if (res.length === 0) {
        return
      }
      console.log('sendLogger loggerResult', res)
      const img = new Image()
      img.style.display = 'none'
      const removeImage = function () {
        img.parentNode.removeChild(img)
      }
      img.onload = removeImage
      img.onerror = removeImage
      img.src = `${state.logUrl}?params=${JSON.stringify(res)}`
      document.body.appendChild(img)
      commit('resetLogger')
    }
  }
}